export default __webpack_public_path__ + "static/media/Pilgrim's Boots of the Purple Sun.ddf0b679.jpg";